/**
 * "Bienvenida" / "Bienvenido" según el sexo biológico registrado
 * (1 = masculino, 2 = femenino). Sin dato (p. ej. persona jurídica o una
 * sesión iniciada antes de este cambio) usa una forma neutra.
 */
export const saludoBienvenida = (sexo?: number | null): string =>
  sexo === 2 ? "Bienvenida" : sexo === 1 ? "Bienvenido" : "Te damos la bienvenida";
